/*
 * Author: Dw
 * File Created: Tuesday, 24-07-30 11:48 am
 * Last Modified: Friday, 24-08-23 12:02 am, by Dw
 */

function FilledMore() {
  return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="FilledMore" data-sentry-source-file="index.tsx">
      <rect width="18" height="18" rx="4" fill="white" fillOpacity="0.1" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
      <circle cx="9" cy="5.3999" r="1" fill="currentColor" data-sentry-element="circle" data-sentry-source-file="index.tsx" />
      <circle cx="9" cy="9" r="1" fill="currentColor" data-sentry-element="circle" data-sentry-source-file="index.tsx" />
      <circle cx="9" cy="12.5999" r="1" fill="currentColor" data-sentry-element="circle" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default FilledMore;